import React, { PureComponent, ReactNode } from "react";
import { AppContextType } from "../../AppContext";
import { ChordSoundingArpeggiation } from "../../models/ChordHistoryOptions.model";
import OptionMenuToggle from "../theme_reuse/OptionMenuToggle";

interface Props {}
interface State {}

const TITLE = "Sounding: arpeggiate?";
const shortNames = [ChordSoundingArpeggiation.None, ChordSoundingArpeggiation.Fast, ChordSoundingArpeggiation.Slow];
const descriptions = [
  "All the notes in a chord are sounded at the same time.",
  "The notes in a chord are sounded in quick ascending order.",
  "The notes in a chord are sounded in slow ascending order.",
];

function printShortName(a: ChordSoundingArpeggiation): string {
  switch (a) {
    case ChordSoundingArpeggiation.None:
      return "No";
    case ChordSoundingArpeggiation.Fast:
      return "Quickly";
    case ChordSoundingArpeggiation.Slow:
      return "Slowly";
  }
}

export default class ChordSoundArpeggiationToggle extends PureComponent<Props, State> {
  declare context: React.ContextType<typeof AppContextType>;
  constructor(props: Props) {
    super(props);
    this.state = {};
  }

  changeSoundingArpeggiation = (arpeggiation: ChordSoundingArpeggiation) => {
    const oldSounding = this.context.chordHistoryOptions.sounding;
    this.context.dispatch({ type: "EditChordHistoryOptions", payload: { sounding: { ...oldSounding, arpeggiation } } });
  };

  render(): ReactNode {
    const { sounding } = this.context.chordHistoryOptions;
    return (
      <OptionMenuToggle
        title={TITLE}
        optionShortNames={shortNames}
        optionDescriptions={descriptions}
        selected={sounding.arpeggiation}
        printShortName={printShortName}
        onChange={this.changeSoundingArpeggiation}
      />
    );
  }
}

ChordSoundArpeggiationToggle.contextType = AppContextType;
